import { differenceInCalendarDays, format, formatDistanceToNow, getTime } from 'date-fns';
import { formatWithOptions } from 'date-fns/fp';
import ptBR from 'date-fns/locale/pt-BR';

// ----------------------------------------------------------------------

function isValidDate(date) {
  const parsedDate = new Date(date);
  // eslint-disable-next-line no-restricted-globals
  return !isNaN(parsedDate.getTime());
}

export function fDate(date, newFormat) {
  if (!isValidDate(date)) return '';

  if (!date) return '';

  const fm = newFormat || 'dd MMM yyyy';

  const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (dateFormatRegex.test(date)) {
    date = new Date(`${date}T00:00:00`);
  } else {
    date = new Date(date);
  }

  return date ? formatWithOptions({ locale: ptBR }, fm, date) : '';
}

export function fDateSlash(date) {
  if (!isValidDate(date)) return '';

  if (!date) return '';

  const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (dateFormatRegex.test(date)) {
    date = new Date(`${date}T00:00:00`);
  } else {
    date = new Date(date);
  }

  return date ? formatWithOptions({ locale: ptBR }, 'dd/MM/yyyy', date) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fDateBrToEn(date) {
  if (!date) return '';

  const brFormatRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (brFormatRegex.test(date)) {
    const [day, month, year] = date.split('/');
    return `${year}-${month}-${day}`;
  }

  const enFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (enFormatRegex.test(date)) {
    return date;
  }

  return date;
}

export function fDateEnToBr(date) {
  if (!date) return '';

  const enFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (enFormatRegex.test(date)) {
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  }

  const brFormatRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (brFormatRegex.test(date)) {
    return date;
  }

  return date;
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
      addSuffix: true,
      locale: ptBR,
    })
    : '';
}

export function getDurationInDays(startDate, endDate) {
  return differenceInCalendarDays(endDate, startDate);
}

export function convertTimestampToISODate(timestamp) {
  const date = new Date(timestamp._seconds * 1000 + timestamp._nanoseconds / 1000000);

  return date.toISOString();
}

export function formatTimeRemaining(deadlineDate) {
  const ms = new Date(deadlineDate).getTime() - Date.now();

  if (ms <= 0)
    return { label: 'Expirado', expired: true };

  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (totalMinutes < 1)
    return { label: '< 1min', expired: false };

  if (hours === 0)
    return { label: `${minutes}min`, expired: false };

  return { label: `${hours}h ${minutes}min`, expired: false };
}